<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// 1. 移除了未使用的 mapState 和 mapGetters
import { parseQuery } from "@utils";

export default {
  name: "App",
  data() {
    return {};
  },
  provide() {
    return { app: this };
  },
  created() {
    // 3. 直接调用初始化逻辑，移除未使用的 initializeApp action
    this.initializeApp();
  },
  destroyed() {
    this.$store.commit("LOGOUT");
  },
  methods: {
    async initializeApp() {
      try {
        // const token =
        //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHQiOjE3NzA4ODcwNTY0MzIsImVpZCI6ImM3ODY5NDQ5YjgyNTQ2ZTViYTZmYWFkMWU2MGYxZjBmIiwidWlkIjoiYzc4Njk0NDliODI1NDZlNWJhNmZhYWQxZTYwZjFmMGYiLCJ4aWQiOiJjNzg2OTQ0OWI4MjU0NmU1YmE2ZmFhZDFlNjBmMWYwZiIsImlhdCI6MTc3MDI4MjI1NjQzMn0.EvLyxUW-Zh7qn8tWu7f50mflIqatl_CEzDE_M_GMQjc";
        // 从URL参数获取token和liveId
        const token = this.$route.query.token || parseQuery()["token"];
        if (token) {
          // 初始化用户状态和直播信息
          this.$store.commit("LOGIN", token);
        }
      } catch (error) {
        console.error("应用初始化失败:", error);
        this.$toast("初始化失败，请刷新页面重试");
      }
    },
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body,
html {
  margin: 0;
  padding: 0;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
